import React, { createContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import useMobileFormActions from '../hooks/useMobileFormActions';
import { useExtendedFormActions, mobileFormTypes } from '../hooks/useExtendedFormActions';
import { ApplicationsService } from '../../../services/applicationsService';

const MobileFormContext = createContext({ updateMobileFormField: () => {} });

const useContextValue = ({ idService, itemType = mobileFormTypes.service, idApp }) => {
  const summaryData = useMobileFormActions(idService);
  const { uploadEvidences } = useExtendedFormActions({ itemId: idService, itemType });
  const [applicationForm, setApplicationForm] = useState(null);

  useEffect(() => {
    if (!idApp) return;
    ApplicationsService.getFormById(idApp)
      .then(({ application }) => setApplicationForm(application?.form ?? []))
      .catch(console.error);
  }, [idApp]);

  const contextValue = useMemo(() => {
    return {
      updateMobileFormField: summaryData.updateMobileFormField,
      getEvidencesSignedPost: summaryData.getEvidencesSignedPost,
      getAttachmentsSignedPost: summaryData.getAttachmentsSignedPost,
      uploadEvidences,
      isUpdateAfterFinish: summaryData.isUpdateAfterFinish,
      idService,
      idApp,
      applicationForm,
    };
  }, [summaryData, idApp, applicationForm]);

  return contextValue;
};

export const MobileFormProvider = ({ children, idService, itemType, idApp }) => {
  const contextValue = useContextValue({ idService, itemType, idApp });

  return <MobileFormContext.Provider value={contextValue}>{children}</MobileFormContext.Provider>;
};

export const ExtendedFormProvider = ({ children, itemId, itemType }) => {
  const extendedFormActions = useExtendedFormActions({ itemId, itemType });

  const contextValue = useMemo(() => {
    return {
      getEvidencesSignedPost: extendedFormActions.getEvidencesSignedPost,
      getAttachmentsSignedPost: extendedFormActions.getAttachmentsSignedPost,
    };
  }, [extendedFormActions]);

  return <MobileFormContext.Provider value={contextValue}>{children}</MobileFormContext.Provider>;
};

MobileFormProvider.propTypes = {
  children: PropTypes.node,
  idService: PropTypes.string,
  itemType: PropTypes.number,
  idApp: PropTypes.string,
};

ExtendedFormProvider.propTypes = {
  children: PropTypes.node,
  itemId: PropTypes.string,
  itemType: PropTypes.number,
};

export default MobileFormContext;
